export default __webpack_public_path__ + "static/media/about-us-banner-m-cn.bcc6d8cf.webp";